import React from 'react'

import { useTranslation } from 'react-i18next'

import { SectionText } from '../../../../../components/SectionText'

interface PreparationProps {
    classname?: string
}

export const Preparation: React.FC<PreparationProps> = ({ classname }) => {
    const { t } = useTranslation()
    return (
        <div className={`${classname} bg-secondary-green min-h-[500px] h-auto flex items-center justify-center`}>
            <div
                className="w-1/2 h-full text-white flex flex-col items-center justify-center
                sm:w-full sm:py-5 sm:px-5
              ">
                <SectionText
                    className="max-h-full flex flex-col justify-between"
                    title={t('AmbulantOperation.Preparation.title')}
                    hrLineColor="bg-primary-blue">
                    <ul className="list-disc pl-5 flex flex-col justify-between min-h-[350px] py-3">
                        <li>{t('AmbulantOperation.Preparation.intro')}</li>
                        <li>{t('AmbulantOperation.Preparation.appointment')}</li>
                        <ul className="list-['-'] pl-5">
                            <li>&nbsp;{t('AmbulantOperation.Preparation.consent')}</li>
                            <li>&nbsp;{t('AmbulantOperation.Preparation.anesthesia')}</li>
                        </ul>
                        <li>{t('AmbulantOperation.Preparation.explanation')}</li>
                        <li>{t('AmbulantOperation.Preparation.child_explanation')}</li>
                    </ul>
                </SectionText>
            </div>
        </div>
    )
}
